module.exports = __webpack_public_path__ + "img/xp_bar_advanced.ca147a09.svg";